import React, { Component } from 'react'
import PropTypes from 'prop-types'
import 'gsap/umd/TweenMax'
import * as TimelineMax from 'gsap/umd/TimelineMax'

class Transition extends Component {
  componentDidMount() {
    this.tl = new TimelineMax({
      paused: true,
      onComplete: () => {
        this.cb()
      },
      onReverseComplete: () => {
        this.cb()
      },
    })

    this.props.timeline(this.tl)
  }

  cb() {
    return this
  }

  componentWillEnter(cb) {
    this.cb = cb
    this.tl.play()
  }

  componentWillAppear(cb) {
    this.cb = cb
    this.tl.play()
  }

  componentWillLeave(cb) {
    const { exitTimeScale, exitTimeline } = this.props

    if (exitTimeline) {
      const tl = new TimelineMax({ onComplete: cb })
      exitTimeline(tl)
    } else {
      this.cb = cb
      this.tl.timeScale(exitTimeScale)
      this.tl.reverse()
    }
  }

  render() {
    return React.cloneElement(
      this.props.children,
      { ...this.props },
    )
  }
}

Transition.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line
  exitTimeline: PropTypes.func,
  exitTimeScale: PropTypes.number,
  timeline: PropTypes.func.isRequired,
}

Transition.defaultProps = {
  exitTimeScale: 1,
  exitTimeline: undefined,
}

export default Transition



// WEBPACK FOOTER //
// ./src/components/Transition.js